var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 0.75H2.58333C1.575 0.75 0.75 1.575 0.75 2.58333V9C0.75 10.0083 1.575 10.8333 2.58333 10.8333H15.4167C16.425 10.8333 17.25 10.0083 17.25 9V2.58333C17.25 1.575 16.425 0.75 15.4167 0.75ZM15.4167 6.25H11.75C11.75 7.735 10.485 9 9 9C7.515 9 6.25 7.735 6.25 6.25H2.58333V2.58333H15.4167V6.25ZM11.75 12.6667H17.25V15.4167C17.25 16.425 16.425 17.25 15.4167 17.25H2.58333C1.575 17.25 0.75 16.425 0.75 15.4167V12.6667H6.25C6.25 14.1883 7.47833 15.4167 9 15.4167C10.5217 15.4167 11.75 14.1883 11.75 12.6667Z",
    fill: "#3EC6FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/productIcon.cee77ad2.svg";
export { ForwardRef as ReactComponent };